import { APIGet, APIPost, APIDelete, IAPIResponse } from "api/protocols";
import { CancelToken } from "axios";

const apiVersion = "2024-04";
const baseUrl = "/" + apiVersion + "/customer/payment-method";

type CustomerPaymentMethod = "card" | "gift_card" | "rain_check";

export interface ICustomerPaymentMethod {
  id: number;
  client_id: number;
  customer_id: number;
  brand: string;
  exp_month: number;
  exp_year: number;
  expiry: string;
  last4: string;
  status?: "valid" | "expired";
  stripe_payment_method_id: string;
  type: CustomerPaymentMethod;
}

export interface ICustomerPaymentMethods {
  card: Array<ICustomerPaymentMethod>;
  // gift_card
  // rain_check
}

export interface IPostCustomerPaymentMethodParams {
  payment_method_id: string;
  save_card: boolean;
  facility_id?: number;
}

export interface IGetCustomerPaymentMethods {
  id?: number;
  client_id?: number;
  type?: Array<CustomerPaymentMethod>;
  include_expired?: boolean;
}

export async function GetCustomerPaymentMethods(
  params: IGetCustomerPaymentMethods,
  useGlobalLoader: boolean,
  cancelToken?: CancelToken,
): Promise<IAPIResponse<ICustomerPaymentMethods>> {
  return await APIGet(baseUrl, params, useGlobalLoader, cancelToken);
}

export async function PostSetup(params: { facility_id?: number }, useGlobalLoader?: boolean) {
  return await APIPost(baseUrl + "/setup", params, useGlobalLoader);
}

export async function PostPaymentMethod(params: IPostCustomerPaymentMethodParams, useGlobalLoader?: boolean) {
  return await APIPost(baseUrl, params, useGlobalLoader);
}

export async function DeleteCustomerPaymentMethod(params: { id: number }, useGlobalLoader: boolean) {
  return await APIDelete(baseUrl, params, useGlobalLoader);
}
